import { render, staticRenderFns } from "./BlogVideo.vue?vue&type=template&id=6585b5ed&scoped=true&"
import script from "./BlogVideo.vue?vue&type=script&lang=js&"
export * from "./BlogVideo.vue?vue&type=script&lang=js&"
import style0 from "./BlogVideo.vue?vue&type=style&index=0&id=6585b5ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6585b5ed",
  null
  
)

export default component.exports